export default "__VITE_ASSET__40647040__"